<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Customers"
                                type="gradient-red"
                                icon="fas fa-user-friends"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span><h3>{{dash['total_customer']}}</h3></span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Wholesaler"
                                type="gradient-orange"
                                icon="fas fa-cubes"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span><h3>{{dash['total_wholesaler']}}</h3></span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Retailer"
                                type="gradient-green"
                                icon="fas fa-store"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span><h3>{{dash['total_retailer']}}</h3></span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Riders"
                                type="gradient-info"
                                icon="fas fa-motorcycle"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span><h3>{{dash['total_riders']}}</h3></span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="font-weight-bold text-primary">User Table</h4>
                                </div>
                                <div class="card-tools col-md-2">
                                    <button class="btn btn-success btn-sm" data-toggle="modal"  data-target="#addUser" @click="newModal">Add new user <i
                                            class="fa fa-user-plus fa-fw"></i></button>
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                        <!-- /.box-header -->
                        <tabs
                                :tabs="tabs"
                                :currentTab="currentTab"
                                :wrapper-class="'default-tabs'"
                                :tab-class="'default-tabs__item'"
                                :tab-active-class="'default-tabs__item_active'"
                                :line-class="'default-tabs__active-line'"
                                @onClick="handleClick"
                        />
                        <div class="card-body table-responsive no-padding" v-if="currentTab === 'tab1'">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="customer"
                                    :pagination-options="{
                                     enabled: true,
                                    mode: 'pages',
                                    perPage: 10
                                        }"
                                    :search-options="{
                                        enabled: true,
                                     placeholder: 'Search this table',
                                     }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'action'">
                                    <a href="#" @click="editModal(props.row)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>
                                        <a href="#" @click="deleteUser(props.row.id)">
                                            <i class="fa fa-trash text-red"></i>
                                        </a>
                                    </span>
                                    <span v-if="props.column.field == 'details'">
                                        <router-link :to="{path: '/userDetails/' + props.row.id}">
                                            <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <!-- /.box-body -->
                        <div class="card-body table-responsive no-padding" v-if="currentTab === 'tab2'">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="wholesaler"
                                    :pagination-options="{
                                     enabled: true,
                                    mode: 'pages',
                                    perPage: 10
                                        }"
                                    :search-options="{
                                        enabled: true,
                                     placeholder: 'Search this table',
                                     }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'action'">
                                    <a href="#" @click="editModal(props.row)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>
                                        <a href="#" @click="deleteUser(props.row.id)">
                                            <i class="fa fa-trash text-red"></i>
                                        </a>
                                    </span>
                                    <span v-if="props.column.field == 'details'">
                                        <router-link :to="{path: '/userDetails/' + props.row.id}">
                                            <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <!-- /.box-body -->
                        <div class="card-body table-responsive no-padding" v-if="currentTab === 'tab3'">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="retailer"
                                    :pagination-options="{
                                     enabled: true,
                                    mode: 'pages',
                                    perPage: 10
                                        }"
                                    :search-options="{
                                        enabled: true,
                                     placeholder: 'Search this table',
                                     }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'action'">
                                    <a href="#" @click="editModal(props.row)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>
                                        <a href="#" @click="deleteUser(props.row.id)">
                                            <i class="fa fa-trash text-red"></i>
                                        </a>
                                    </span>
                                    <span v-if="props.column.field == 'details'">
                                        <router-link :to="{path: '/userDetails/' + props.row.id}">
                                            <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <!-- /.box-body -->
                        <div class="card-body table-responsive no-padding" v-if="currentTab === 'tab4'">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="rider"
                                    :pagination-options="{
                                     enabled: true,
                                    mode: 'pages',
                                    perPage: 10
                                        }"
                                    :search-options="{
                                        enabled: true,
                                     placeholder: 'Search this table',
                                     }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'action'">
                                    <a href="#" @click="editModal(props.row)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>
                                        <a href="#" @click="deleteUser(props.row.id)">
                                            <i class="fa fa-trash text-red"></i>
                                        </a>
                                    </span>
                                    <span v-if="props.column.field == 'details'">
                                        <router-link :to="{path: '/userDetails/' + props.row.id}">
                                            <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <!-- /.box-body -->
                        <div class="card-body table-responsive no-padding" v-if="currentTab === 'tab5'">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="users"
                                    :pagination-options="{
                                     enabled: true,
                                    mode: 'pages',
                                    perPage: 10
                                        }"
                                    :search-options="{
                                        enabled: true,
                                     placeholder: 'Search this table',
                                     }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'action'">
                                    <a href="#" @click="editModal(props.row)">
                                            <i class="fa fa-edit text-teal"></i>
                                        </a>
                                        <a href="#" @click="deleteUser(props.row.id)">
                                            <i class="fa fa-trash text-red"></i>
                                        </a>
                                    </span>
                                    <span v-if="props.column.field == 'details'">
                                        <router-link :to="{path: '/userDetails/' + props.row.id}">
                                            <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                        </div>
                        <!-- /.box-body -->
                    </div>
                    <!-- /.box -->
                </div>


            </div>
        </div>
        <!--BOOTSTRAP MODAL-->
        <div class="modal fade addUser-modal-lg" tabindex="-1"   id="addUser" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="!isEdit">Add User</h4>
                        <h4 v-if="isEdit">Edit User</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form method="post" @submit.prevent="createUser">
                            <div class="form-group">
                                <label>User Name</label>
                                <input v-model="form.name" type="text" name="name" placeholder="Name"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.name">{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input v-model="form.phone" type="tel" name="phone" placeholder="0700000000"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.phone">{{ errors.phone[0] }}
                                </small>
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input v-model="form.email" type="email" name="email" placeholder="email@email.com"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.email">{{ errors.email[0] }}
                                </small>
                            </div>
                            <div class="form-group">
                                <label>County</label>
                                <input v-model="form.county" type="tel" name="county" placeholder="county"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.county">{{ errors.county[0] }}
                                </small>
                            </div>
                            <div class="form-group">
                                <label>Town</label>
                                <input v-model="form.town" type="text" name="town" placeholder="town"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.town">{{ errors.town[0] }}
                                </small>
                            </div>
                            <div class="form-group" v-if="!isEdit">
                                <label>Password</label>
                                <input v-model="form.password" type="password" name="password" placeholder="******(Password)"
                                       class="form-control" >
                                <small style="color: red" v-if="error && errors.password">{{ errors.password[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label>Role</label>
                                <select name="type" v-model="form.role" id="role" class="form-control">
                                    <option value="">Select User Role</option>
                                    <option value="admin">Admin</option>
                                    <option value="customer">Customer</option>
                                    <option value="retailer">Retailer</option>
                                    <option value="wholesaler">Wholesaler</option>
                                    <option value="rider">Rider</option>
                                </select>
                                <small style="color: red" v-if="error && errors.role">{{ errors.role[0] }}</small>
                            </div>
                            <div class="form-group" v-if="form.role == 'retailer' || form.role == 'wholesaler'">
                                <label>Shop Name</label>
                                <input v-model="form.shop" type="text" name="shop" placeholder="Shop Name"
                                       class="form-control">
                                <small style="color: red" v-if="error && errors.shop">{{ errors.shop[0] }}
                                </small>
                            </div>
                            <hr>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="close">Close</button>
                                <button type="submit" class="btn btn-success btn-sm" v-if="!isEdit">Add User</button>
                                <button type="button" class="btn btn-success btn-sm" v-if="isEdit" @click="updateUser">
                                    Update User
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
        <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"></loading>
        </div>


    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    //import tabs
    import Tabs from 'vue-tabs-with-active-line';

    const TABS = [{
        title: 'Customers',
        value: 'tab1',
    }, {
        title: 'Wholesaler',
        value: 'tab2',
    }, {
        title: 'Retailer',
        value: 'tab3',
    }, {
        title: 'Riders',
        value: 'tab4',
    }, {
        title: 'Admin',
        value: 'tab5',
    }];
    export default {
        name: "UserManager",
        components: {
            Loading,
            Tabs
        },
        data() {

            return {
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'Email',
                        field: 'email',
                    },
                    {
                        label: 'Phone',
                        field: 'phone',
                    },
                    {
                        label: 'County',
                        field: 'county',
                    },
                    {
                        label: 'Town',
                        field: 'location_name',
                    },
                    {
                        label: 'View',
                        field: 'details'
                    },
                    {
                        label: 'Action',
                        field: 'action'
                    }
                ],
                fd: new FormData(),
                attachments: [],
                users: [],
                customer: [],
                rider: [],
                wholesaler: [],
                retailer: [],

                tabs: TABS,
                currentTab: 'tab1',
                isLoading: false,
                isEdit: false,
                fullPage: true,
                errors: {},
                error: false,
                dash:{},
                form: {
                    id: '',
                    name: '',
                    email: '',
                    phone: '',
                    password: '',
                    role: '',
                    county: '',
                    town: '',
                    village: '',
                }
            }
        },
        methods: {
            handleClick(newTab) {
                this.currentTab = newTab;
            },
            getResults(page = 1) {
                this.axios.get('/admin/user?page=' + page)
                    .then(response => {
                        this.users = response.data;
                    });
            },
            updateUser() {
                this.axios.post('/admin/users/' + this.form.id , this.form)
                    .then(() => {
                        $('#addUser').modal('hide');
                        this.$swal.fire(
                            'Edited!',
                            'User information updated.',
                            'success'
                        )
                        this.$Progress.finish();
                        this.loadUsers();
                        this.loadWholesaler();
                        this.loadRetailer();
                        this.loadRider();
                        this.loadCustomer();
                        this.loadDashboard();
                    })
                    .catch((error) => {
                        this.$Progress.fail();
                        this.isLoading = false;
                        this.error = true;
                        this.errors = error.response.data.errors;

                        this.$swal("Failed!", "There was something wrong.", "warning");
                    })
            },
            editModal(user) {
                $('#addUser').modal('show');
                this.isEdit = true;
                this.form = {
                    id: '',
                    name: '',
                    email: '',
                    phone: '',
                    password: '',
                    role: '',
                    county: '',
                    town: '',
                    village: '',
                };
                this.form.id = user.id;
                this.form.name = user.name;
                this.form.email = user.email;
                this.form.phone = user.phone;
                this.form.role = user.role;
                this.form.county = user.county;
                this.form.town = user.location_name;
                this.form.village = user.village;
            },
            newModal() {
                this.editMode = false;
                this.form = {
                    id: '',
                    name: '',
                    email: '',
                    phone: '',
                    password: '',
                    role: '',
                    county: '',
                    town: '',
                    village: '',
                };
            },
            close() {
            $('#addUser').modal('hide');
            },
            deleteUser(id) {
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.delete('/admin/user/' + id, this.form).then(() => {

                            this.$swal.fire(
                                'Deleted!',
                                'User has been deleted.',
                                'success'
                            )

                        });
                        this.loadUsers();
                        this.loadWholesaler();
                        this.loadRetailer();
                        this.loadRider();
                        this.loadCustomer();
                        this.loadDashboard();
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            loadUsers() {
                this.axios.get("/admin/user").then(({data}) => ([this.users = data]));
            },
            loadCustomer() {
                this.axios.get("/admin/customer").then(({data}) => ([this.customer = data]));
            },
            loadRider() {
                this.axios.get("/admin/rider").then(({data}) => ([this.rider = data]));
            },
            loadWholesaler() {
                this.axios.get("/admin/wholesaler").then(({data}) => ([this.wholesaler = data]));
            },
            loadRetailer() {
                this.axios.get("/admin/retailer").then(({data}) => ([this.retailer = data]));
            },
            loadDashboard() {
                this.axios.get("/admin/dashboard").then(({data}) => ([this.dash = data['data']]));
            },
            createUser() {
                this.$Progress.start();
                this.isLoading = true;
                this.fd.append('id', this.form.id);
                this.fd.append('name', this.form.name);
                this.fd.append('email', this.form.email);
                this.fd.append('phone', this.form.phone);
                this.fd.append('password', this.form.password);
                this.fd.append('role', this.form.role);
                this.fd.append('county', this.form.county);
                this.fd.append('town', this.form.town);
                this.fd.append('village', this.form.village);
                this.fd.append('shop', this.form.shop);

                const config = {headers: {'Content-Type': 'multipart/form-data'}};
                this.axios.post('/admin/user' , this.fd, config)
                    .then(() => {
                        this.isLoading = false;
                        $('#addUser').modal('hide');
                        this.form = {
                            id: '',
                            name: '',
                            email: '',
                            phone: '',
                            password: '',
                            role: '',
                            county: '',
                            town: '',
                            village: '',
                        };
                        this.$Progress.finish();
                        this.loadUsers();
                        this.loadWholesaler();
                        this.loadRetailer();
                        this.loadRider();
                        this.loadCustomer();
                        this.loadDashboard();
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.isLoading = false;
                        this.error = true;
                        this.errors = error.response.data.errors;

                    })
            }
        },


        created() {
            this.loadUsers();
            this.loadWholesaler();
            this.loadRetailer();
            this.loadRider();
            this.loadCustomer();
            this.loadDashboard();
        }

    }
</script>

<style lang="scss">
    .default-tabs {
        position: relative;
        margin: 0 auto;

        &__item {
            display: inline-block;
            margin: 0 5px;
            padding: 10px;
            padding-bottom: 8px;
            font-size: 16px;
            letter-spacing: 0.8px;
            color: gray;
            text-decoration: none;
            border: none;
            background-color: transparent;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            transition: all 0.25s;

            &_active {
                color: black;
            }

            &:hover {
                border-bottom: 2px solid gray;
                color: red;
            }

            &:focus {
                outline: none;
                border-bottom: 2px solid gray;
                color: green;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }

        &__active-line {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 2px;
            background-color: blue;
            transition: transform 0.4s ease, width 0.4s ease;
        }
    }

    .content {
        margin-top: 30px;
        font-size: 20px;
    }
</style>